/* Glassheart Society — theme behaviour.
   Replaces the client-side state the design draft handled itself. */

(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HKD',
    }).format(cents / 100);

  /* ---------- Cart quantity and remove ---------- */
  async function changeLine(line, quantity) {
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (!res.ok) throw new Error('Could not update the bag.');
    return res.json();
  }

  document.addEventListener('click', async (e) => {
    const row = e.target.closest('[data-line]');
    if (!row) return;

    const qtyEl = row.querySelector('[data-qty]');
    const current = Number((qtyEl && qtyEl.textContent.trim()) || 0);
    let next = null;

    if (e.target.closest('[data-qty-up]')) next = current + 1;
    if (e.target.closest('[data-qty-down]')) next = Math.max(1, current - 1);
    if (e.target.closest('[data-remove]')) next = 0;
    if (next === null || next === current) return;

    e.preventDefault();
    try {
      await changeLine(Number(row.dataset.line), next);
      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  });

  /* ---------- Product page ---------- */
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const jsonEl = document.querySelector('[data-variant-json]');
  const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
  const idInput = section.querySelector('[data-variant-id]');
  const priceEl = section.querySelector('[data-price]');
  const button = section.querySelector('[data-add-button]');
  const label = section.querySelector('[data-add-label]');
  const hint = section.querySelector('[data-add-hint]');
  const hero = section.querySelector('[data-hero-image]');

  /* Gallery thumbnails */
  section.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (hero) hero.src = thumb.dataset.src;
      section.querySelectorAll('[data-thumb]').forEach((t) => (t.style.opacity = '.45'));
      thumb.style.opacity = '1';
    });
  });

  const chosen = () =>
    [...section.querySelectorAll('[data-option-input]:checked')].map((i) => i.value);

  function paintSelection() {
    section.querySelectorAll('[data-option-input]').forEach((input) => {
      const wrap = input.closest('label');
      if (!wrap) return;
      const on = input.checked;
      wrap.classList.toggle('is-on', on);
      wrap.classList.toggle('gh-size--on', on && wrap.classList.contains('gh-size'));
      const rule = wrap.querySelector('span[style*="height:1px"]');
      if (rule) rule.style.background = on ? '#0b0b0b' : 'transparent';
    });

    const colourLabel = section.querySelector('[data-colour-label]');
    if (colourLabel) {
      const colourInput = section.querySelector('[data-option-position="1"] [data-option-input]:checked');
      if (colourInput) colourLabel.textContent = colourInput.value;
    }
  }

  /* Strike through option values that have no available variant
     given everything else currently selected. */
  function paintAvailability() {
    const current = chosen();
    section.querySelectorAll('fieldset[data-option-position]').forEach((set) => {
      const idx = Number(set.dataset.optionPosition) - 1;
      set.querySelectorAll('[data-option-input]').forEach((input) => {
        const test = current.slice();
        test[idx] = input.value;
        const match = variants.find((v) => test.every((val, i) => v.options[i] === val));
        const wrap = input.closest('label');
        if (!wrap) return;
        const out = !match || !match.available;
        wrap.classList.toggle('gh-size--out', out && wrap.classList.contains('gh-size'));
        if (out) wrap.style.opacity = wrap.classList.contains('gh-size') ? '' : '.25';
        else wrap.style.opacity = '';
      });
    });
  }

  function sync() {
    const values = chosen();
    const sets = section.querySelectorAll('fieldset[data-option-position]');

    paintSelection();
    paintAvailability();

    if (values.length < sets.length) {
      button.disabled = true;
      label.textContent = 'Select a size';
      hint.hidden = false;
      return;
    }
    hint.hidden = true;

    const match = variants.find((v) => values.every((val, i) => v.options[i] === val));
    if (!match) {
      button.disabled = true;
      label.textContent = 'Unavailable';
      return;
    }

    idInput.value = match.id;
    priceEl.textContent = fmt(match.price);
    section.querySelectorAll('[data-code]').forEach((el) => {
      if (match.sku) el.textContent = match.sku;
    });
    if (hero && match.featured_image && match.featured_image.src) {
      hero.src = match.featured_image.src;
    }

    button.disabled = !match.available;
    label.textContent = match.available ? 'Add to bag' : 'Sold out';

    const url = new URL(window.location);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url);
  }

  section.addEventListener('change', (e) => {
    if (e.target.matches('[data-option-input]')) sync();
  });

  sync();
})();
